module.exports = __webpack_public_path__ + "static/media/slider-live-img.78ae6cd6.jpg";